<template>
  <v-data-table
    :footer-props="{
      'items-per-page-text': 'Số dữ liệu mỗi trang',
      'items-per-page-options': [10, 20, 50]
    }"
    :headers="headers"
    :items="tableData"
    :items-per-page="itemsPerPage"
    :server-items-length="totalCount"
    :loading="loading"
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    disable-sort
  >
    <template v-slot:no-data>
      <div class="my-12 font-weight-bold">
        <p>Không có dữ liệu</p>
      </div>
    </template>
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1">
          <div :style="{ width: '120px' }">
            <BaseSmallInput
              placeholder="Nhập mã đơn"
              v-model="filter.importOrderCode"
              @change="
                () => {
                  searchWithOption({ importOrderCode_contains: filter.importOrderCode })
                }
              "
            />
          </div>
        </td>
        <td colspan="1">
          <div :style="{ width: '90px' }">
            <SmallSelect
              placeholder="Chọn NH"
              entity="industries"
              @changeSelect="
                val => {
                  searchWithOption({ productIndustry: val })
                  selectChange('productIndustry', val)
                }
              "
            />
          </div>
        </td>
        <td colspan="1">
          <div :style="{ width: '100px' }">
            <SmallSelect
              ref="producerSelect"
              placeholder="Chọn NSX"
              entity="producers"
              :params="{ productIndustry: productIndustry }"
              @changeSelect="
                val => {
                  searchWithOption({ producer: val })
                  selectChange('producer', val)
                }
              "
            />
          </div>
        </td>
        <td colspan="1">
          <div :style="{ width: '115px' }">
            <SmallSelect
              ref="productTypeSelect"
              placeholder="Chọn CH"
              entity="productTypes"
              :params="{ producer: producer, productIndustry: productIndustry }"
              @changeSelect="
                val => {
                  searchWithOption({ productType: val })
                }
              "
            />
          </div>
        </td>
        <td colspan="1">
          <div :style="{ width: '200px' }">
            <SmallSelect
              placeholder="Chọn Kho"
              entity="inventories"
              @changeSelect="
                val => {
                  searchWithOption({ inventories: val })
                }
              "
            />
          </div>
        </td>
        <td colspan="1">
          <div :style="{ width: '110px' }">
            <StatusSelect
              :items="deliveryStatusSelect"
              placeholder="Chọn TT"
              @onChangeStatus="val => searchWithOption({ deliveryStatus: val })"
            ></StatusSelect>
          </div>
        </td>
        <td></td>
        <td></td>
        <td style="text-align: end">
          <div class="text-red">{{ formatNumber(stats.expectedQuantity) }}</div>
        </td>
        <td style="text-align: end">
          <div class="text-red">{{ formatNumber(stats.actualQuantity) }}</div>
        </td>
        <td style="text-align: end">
          <div class="text-red">{{ formatNumber(stats.remainQuantity) }}</div>
        </td>
        <td></td>
      </tr>
    </template>
    <template v-slot:[`item.importOrderCode`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="$auth.policies['import-deliveries:detail'] ? `/delivery/${item.id}` : ''"
      >
        <div style="white-space: nowrap">
          {{ item.importOrderCode }}
        </div>
      </router-link>
    </template>
    <template v-slot:[`item.deliveryStatus`]="{ item }">
      <TextStatus type="delivery" :status="item.deliveryStatus" />
    </template>
    <template v-slot:[`item.scheduledFrom`]="{ item }">
      {{ formatDateDDMMYYYY(item.scheduledFrom || '') }}
    </template>
    <template v-slot:[`item.scheduledTo`]="{ item }">
      {{ formatDateDDMMYYYY(item.scheduledTo || '') }}
    </template>
    <template v-slot:[`item.inventories`]="{ item }">
      <div class="d-flex">
        <div v-for="(i, index) in item.inventories" :key="index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="d-flex" v-on="on">
                <span>
                  {{ i.nameShort }}
                </span>
                <span v-if="index !== item.inventories.length - 1">,&nbsp;</span>
              </div>
            </template>
            <span>{{ `Kho ${i.name}` }}</span>
          </v-tooltip>
        </div>
      </div>
    </template>
    <template v-slot:[`item.expectedQuantity`]="{ item }">
      <div class="text-red">
        {{ formatNumber(item.expectedQuantity) }}
      </div>
    </template>
    <template v-slot:[`item.actualQuantity`]="{ item }">
      <div class="text-red">
        {{ formatNumber(item.actualQuantity) }}
      </div>
    </template>
    <template v-slot:[`item.remainingQuantity`]="{ item }">
      <div class="text-red">
        {{ formatNumber(item.remainingQuantity) }}
      </div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        v-if="$auth.policies['import-deliveries:detail']"
        @click="$router.push(`/delivery/${item.id}`)"
        size="20"
        color="primary"
        >mdi-eye</v-icon
      >
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import SmallSelect from '../../components/samnec/SmallSelect.vue'
import StatusSelect from '@/components/basic/StatusSelect.vue'
import TextStatus from '@/components/samnec/TextStatus.vue'
import { deliveryStatusSelect } from '../../helpers/data'
import { get, isEmpty } from 'lodash'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import BaseSmallInput from '../../components/basic/BaseSmallInput.vue'
export default {
  components: {
    SmallSelect,
    StatusSelect,
    TextStatus,
    BaseSmallInput
  },
  data() {
    return {
      headers: [
        { text: 'Đơn hàng nhập', value: 'importOrderCode', width: '120px' },
        { text: 'Ngành hàng', value: 'productIndustry', width: '90px' },
        { text: 'NSX', value: 'producer', width: '100px' },
        { text: 'Chủng hàng', value: 'productType', width: '115px' },
        { text: 'Kho', value: 'inventories', width: '200px' },
        { text: 'Trạng thái', value: 'deliveryStatus', width: '110px' },
        { text: 'Từ ngày', value: 'scheduledFrom', width: '85px' },
        { text: 'Đến ngày', value: 'scheduledTo', width: '85px' },
        { text: 'SL nhập', value: 'expectedQuantity', width: '80px', align: 'end' },
        { text: 'Đã về', value: 'actualQuantity', width: '80px', align: 'end' },
        { text: 'Còn', value: 'remainingQuantity', width: '80px', align: 'end' },
        { text: 'Thao tác', value: 'actions', width: '100px', align: 'center' }
      ],
      filter: {
        importOrderCode: ''
      },
      productIndustry: '',
      producer: ''
    }
  },
  computed: {
    ...mapState({
      tableData(state) {
        const dataHandle = state['importDeliveries'].items.map(i => {
          return {
            ...i,
            producer: get(i, 'producer.name', ''),
            productIndustry: get(i, 'productIndustry.name', ''),
            productType: get(i, 'productType.name', ''),
            remainingQuantity: get(i, 'expectedQuantity', 0) - get(i, 'actualQuantity', 0),
            inventories: this.getNameInventories(get(i, 'data.inventories', {}))
          }
        })
        return dataHandle
      },
      totalCount(state) {
        return state['importDeliveries'].count
      },
      stats(state) {
        return state['importDeliveries'].stats
      },
      loading(state) {
        return state['importDeliveries'].loading
      },
      searchQuery(state) {
        return {
          ...state['importDeliveries'].searchQuery,
          status: ['open', 'closed']
        }
      },
      itemsPerPage(state) {
        return state['importDeliveries'].itemsPerPage
      },
      deliveryStatusSelect: () => {
        return deliveryStatusSelect().filter(i => i.value !== 'toInventory')
      }
    }),
    allProductDelivery() {
      return this.productDelivery.map(v => {
        const remaining = v.quantity - v.arrivement || 0
        return { ...v, remaining: remaining > 0 ? remaining : 0 }
      })
    }
  },
  async created() {
    const params = { status: ['open', 'closed'] }
    await this.fetchItems({ ...params, _start: 0, _limit: this.itemsPerPage })
    await this.fetchStats(params)
    await this.countItems(params)
    this.setSearchQuery({})
  },
  methods: {
    ...mapActions({
      fetchItems: 'importDeliveries/fetchItems',
      fetchStats: 'importDeliveries/fetchStats',
      countItems: 'importDeliveries/countItems'
    }),
    ...mapMutations({
      setItemsPerPage: 'importDeliveries/setItemsPerPage',
      setSearchQuery: 'importDeliveries/setSearchQuery'
    }),
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      await this.fetchItems({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.searchQuery
      })
      this.setItemsPerPage(itemsPerPage)
    },
    formatNumber(number) {
      return !isNaN(Number(number)) ? Number(number).toLocaleString() : '0'
    },
    async searchWithOption(val) {
      const query = { ...this.searchQuery, ...val }
      await this.fetchItems({ ...query, _start: 0, _limit: this.itemsPerPage })
      await this.fetchStats(query)
      await this.countItems(query)
      this.setSearchQuery(query)
    },
    getNameInventories(inventories) {
      if (isEmpty(inventories)) return ''
      return Object.values(inventories).map(i => ({ nameShort: i.name_short, name: i.name }))
      // return arrName.join(', ')
    },
    selectChange(type, val) {
      if (type === 'productIndustry') {
        this.productIndustry = val
        setTimeout(() => {
          this.$refs.producerSelect.changeItems()
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'producer') {
        this.producer = val
        setTimeout(() => {
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
    },
    formatDateDDMMYYYY: formatDateDDMMYYYY
  }
}
</script>
<style lang="scss">
td,
th {
  padding: 0 8px !important;
}
</style>
<style lang="scss" scoped>
.text-red {
  color: red;
}
</style>
